import React from 'react'
import { InputText } from 'primereact/inputtext'

const IdaFilterTemplate = ({ options, field }) => {
    return (
        <InputText
            value={options.value || ''}
            onChange={(e) => {
                const value = e.target.value === '' ? ' ' : e.target.value
                options.filterCallback(value, options.index)
            }}
            placeholder={`Search by ${field}`}/>
    )
}

export default IdaFilterTemplate
